import * as React from "react";
import * as main from "../../main.module.scss";
import * as program from "./style.module.scss";
import gallery from "./gallery.json";
import { CarouselFullscreen } from "../../../../CarouselFullscreen";
const Slides = ({ day }) => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return (
    gallery.map((elem, index) => (
      day === elem.day && <div className={program.slides} key={index}>
        <h5>Посмотрите слайды<br/> презентации этого урока:</h5>
        <div className={program.slidesList}>
          {
            elem.slidesPreviews.map((e, i) => (
              <button key={i} aria-label={`button-${i}`} onClick={() => {
                setFullScreenState({ open: true, selectedSlideIndex: i });
              }}>
                <img src={e} alt=""/>
              </button>
            ))
          }
        </div>
        <CarouselFullscreen
          data={elem.slidesBig.map((e) => (
            <img src={e} alt="" style={{ maxHeight: "80vh" }}/>
          ))}
          open={fullScreenState.open}
          selectedSlideIndex={fullScreenState.selectedSlideIndex}
          onClose={() => {
            setFullScreenState({ open: false, selectedSlideIndex: 0 });
          }}
        />
      </div>
    ))
  );
};
const Gallery = ({ day }) => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return (
    gallery.map((elem, index) => (
      day === elem.day && <div className={program.gallery} key={index}>
        {
          elem.screensPreviews.map((e, i) => (
            <button className={program.screenBtn} key={i} aria-label={`button-${i}`} onClick={() => {
              setFullScreenState({ open: true, selectedSlideIndex: i });
            }}>
              <img src={e} alt=""/>
            </button>
          ))
        }
        <Slides day={day}/>

        <CarouselFullscreen
          data={elem.screensBig.map((e) => (
            <img src={e} alt="" style={{ maxHeight: "80vh" }}/>
          ))}
          open={fullScreenState.open}
          selectedSlideIndex={fullScreenState.selectedSlideIndex}
          onClose={() => {
            setFullScreenState({ open: false, selectedSlideIndex: 0 });
          }}
        />
      </div>
    ))
  );
}
export const Program = () => {
  return (
    <section className={program.program}>
      <div className="container">
        <h2 className={main.title}>Программа марафона</h2>
        <p className={main.subtitle}>5 дней, которые изменят будущее вашего ребенка</p>
        <ul className={program.mainList}>
          <li>
            <a href="#tt"><h3><span>День #1.</span> Проблемы образования вашего ребенка</h3></a>
            <div className={program.infoWrap}>
              <Gallery day={1}/>
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.author}>Александр Згода</p>
                    <p className={program.time}>1 час 25 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>6 причин детской неуспеваемости в школе</li>
                  <li>Что будет, если ребенка заставлять учиться?</li>
                  <li>Нужен ли моему ребенку репетитор?</li>
                  <li>Есть ли смысл ругать и наказывать ребенка?</li>
                  <li>Как школьная система оценок учит бояться?</li>
                  <li>Как стоит реагировать на плохие оценки у ребенка?</li>
                  <li>До какого возраста есть вероятность перевоспитать детей?</li>
                </ul>
              </div>
            </div>
            <div className={program.filesWrap}>
              <h4>Файлы, которые вы получите:</h4>
              <a href="#tt" aria-label={'ссылка на регистрацию'}>
                <ul className={program.filesList}>
                  <li className={program.course}>
                    <h5>Мастер-класс по ДЗ</h5>
                    <p>Ваш ребенок научится делать домашнее задание легко, быстро и самостоятельно</p>
                  </li>
                  <li className={program.doc}>
                    <h5>Аудит уровня контроля</h5>
                    <p>Оцените степень своего вмешательства в его учебу</p>
                  </li>
                  <li className={program.xls}>
                    <h5>Памятка обучения</h5>
                    <p>Выучите ключевые принципы самостоятельного обучения</p>
                  </li>
                </ul>
              </a>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат первого дня:</h4>
                <p>Вы узнаете главные ошибки, которые совершают родители, пытаясь повысить успеваемость ребенка, и получите понимание ключевых принципов развития самостоятельности в детском возрасте</p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}><h3><span>День #2.</span> Система достижения результата</h3></a>
            <div className={program.infoWrap}>
              <Gallery day={2}/>
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.author}>️Александр Згода</p>
                    <p className={program.time}>1 час 25 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>3 аспекта мотивации детей школьного возраста</li>
                  <li>Знакомство с методикой “колесо детской мотивации”</li>
                  <li>5 принципов успешного выполнения домашних заданий</li>
                  <li>Как развить концентрацию внимания у детей?</li>
                  <li>Практика запоминания иероглифов методом ассоциаций</li>
                  <li>Значение цикла повторений в усваиваемости информации</li>
                  <li>“Принцип сита” в усваивании информации и работе нейронов</li>
                  <li>Техника “Договора с ребенком” для получения результата</li>
                  <li>Обучение для детей с особенностями развития</li>
                </ul>
              </div>
            </div>
            <div className={program.filesWrap}>
              <h4>Файлы, которые вы получите:</h4>
              <a href="#tt" aria-label={'ссылка на регистрацию'}>
                <ul className={program.filesList}>
                  <li className={program.pdf}>
                    <h5>Договор с ребенком</h5>
                    <p>Памятка по заключению договора с ребенком</p>
                  </li>
                </ul>
              </a>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат второго дня:</h4>
                <p>Вы узнаете, как и почему дети учатся, что мотивирует детей к обучению, почему и как с детьми можно договариваться, почему именно положительное подкрепление важно</p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}><h3><span>День #3.</span> Практические упражнения, которые понравятся ребенку</h3></a>
            <div className={program.infoWrap}>
              <Gallery day={3}/>
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.author}>Александр Згода</p>
                    <p className={program.time}>1 час 40 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>Механизм запоминания информации</li>
                  <li>4 основы нейродинамики - базовый коцепт психики</li>
                  <li>3 кита внедрения нового навыка в свою жизнь</li>
                  <li>Принцип декомпозиции в детском обучении</li>
                  <li>Принципы продуктивности в детском возрасте</li>
                  <li>Принципы запоминания информации в работе мозга</li>
                  <li>5 когнитивных упражнений для гармонизации межполушарных связей</li>
                  <li>Метод запоминания иностранных слов со скоростью 100 слов в час</li>
                  <li>Мнемотехника для запоминания таблицы Менделеева за 3 часа</li>
                </ul>
              </div>
            </div>
            <div className={program.filesWrap}>
              <h4>Файлы, которые вы получите:</h4>
              <a href="#tt" aria-label={'ссылка на регистрацию'}>
                <ul className={program.filesList}>
                  <li className={program.course}>
                    <h5>Курс Глобус на пальце</h5>
                    <p>Запомните 200+ стран и их расположение</p>
                  </li>
                </ul>
              </a>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат третьего дня:</h4>
                <p>Вы узнаете, как наш мозг запоминает информацию и освоите принципы успешного запоминания. Прямо на уроке научитесь базовым мнемотехникам, запомните десятки новых иностранных слов без зубрежки и с удовольствием, и по новому посмотрите на свою память!</p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}><h3><span>День #4.</span> Годовая программа школы за два месяца</h3></a>
            <div className={program.infoWrap}>
              <Gallery day={4}/>
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.author}>Александр Згода</p>
                    <p className={program.time}>1 час 25 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>Значение “Знаний” и “Навыков” в школьном обучении ребенка</li>
                  <li>Эволюция развития навыков в жизни человека</li>
                  <li>Система изолированной отработки навыков</li>
                  <li>Базовые принципы продуктивности для обучения</li>
                  <li>Алгоритм решения текстовых школьных задач</li>
                  <li>Алгоритм работы с параграфом и выделение главного</li>
                  <li>Активное воспроизведение и визуализация информации</li>
                  <li>Принцип “Сита запоминания” в подготовке к экзаменам</li>
                  <li>Принцип работы с карточками для изучения школьных предметов</li>
                  <li>Приоритизация основных и побочных задач в школьном обучении</li>
                  <li>Навык быстрого решения задач и увеличение скорости мышления</li>
                  <li>Техника изучения грамматики и фонетики в английском языке</li>
                  <li>Техники изучения правил русского языка от Advance</li>
                  <li>Mind-карты для обучения школьников</li>
                </ul>
              </div>
            </div>
            <div className={program.filesWrap}>
              <h4>Файлы, которые вы получите:</h4>
              <a href="#tt" aria-label={'ссылка на регистрацию'}>
                <ul className={program.filesList}>
                  <li className={program.pdf}>
                    <h5>Карточки по математике</h5>
                    <p>Карточки для запоминания 113 базовых терминов по математике</p>
                  </li>
                </ul>
              </a>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат четвёртого дня:</h4>
                <p>Вы узнаете, как избавиться от зубрежки, как сократить время на домашку, как помнить и понимать разные типы информации</p>
              </div>
            </a>
          </li>
          <li>
            <a href="#tt" aria-label={'ссылка на регистрацию'}><h3><span>День #5.</span> План успешного будущего вашего ребенка</h3></a>
            <div className={program.infoWrap}>
              <Gallery day={5}/>
              <div className={program.themes}>
                <div className={program.head}>
                  <h4>Темы урока:</h4>
                  <div className={program.extra}>
                    <p className={program.author}>Александр Згода</p>
                    <p className={program.time}>1 час 45 мин.</p>
                  </div>
                </div>
                <ul className={program.themesList}>
                  <li>3 составляющие успешного будущего вашего ребенка</li>
                  <li>Жизненные неудачи, которые нужно предупредить еще в детстве</li>
                  <li>Как родителю помочь выстроить успешное будущее ребенка?</li>
                  <li>Горизонт планирования и умение ставить цели</li>
                  <li>Стратегия и тактика в школьном обучении</li>
                  <li>Нужно ли ребенка заставлять учиться и чем это чревато?</li>
                  <li>Помогут ли репетиторы обеспечить успешное будущее ребенка?</li>
                  <li>Стратегия подготовки ребенка к взрослой жизни от Advance</li>
                  <li>Знакомство с обучением вашего ребенка в Advance</li>
                </ul>
              </div>
            </div>
            <div className={program.filesWrap}>
              <h4>Файлы, которые вы получите:</h4>
              <a href="#tt" aria-label={'ссылка на регистрацию'}>
                <ul className={program.filesList}>
                  <li className={program.pdf}>
                    <h5>Гайд по негативной детской мотивации</h5>
                    <p>Выстройте эффективные  отношения с ребенком  для продуктивного обучения</p>
                  </li>
                </ul>
              </a>
            </div>
            <a href="#tt" aria-label={'ссылка на регистрацию'}>
              <div className={program.resultWrap}>
                <h4>Результат пятого дня:</h4>
                <p>Вы узнаете, как помочь ребенку без насилия стать успешным, как помочь ребенку выбрать путь к счастливой жизни и обеспечить свое будущее самостоятельно</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
};
